export enum SettingsName {
  PrimaryColor = 1,
  SecondaryColor = 2,
  TertiaryColor = 3
}
